import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';

import { SaldoDevedorMunicipioService } from './shared/service/saldoDevedorMunicipio.service';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';

import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';
import { Municipio, SaldoDevedorMunicipioFiltro, SaldoDevedorMunicipioModelView } from './shared/model/saldoDevedorMunicipio.model';

@Component({
  selector: 'sarf-saldo-devedor-municipio',
  templateUrl: './saldo-devedor-municipio.component.html'
})

export class SaldoDevedorMunicipioComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  showFile: ShowFile;
  aslibModal: AslibModalComponent;
  municipioSelected: Municipio;
  listaMunicipio: Municipio[];
  DataFim : Date;
  DataInicio: Date;
  tipoRel: number;
  filtro: SaldoDevedorMunicipioFiltro;
  saldoDevedorMunicipioModelView: SaldoDevedorMunicipioModelView;
  exibirGrid:boolean;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;

  constructor(
    private readonly saldoDevedorMunicipioService: SaldoDevedorMunicipioService,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.saldoDevedorMunicipioModelView = new SaldoDevedorMunicipioModelView();
    this.filtro =   new SaldoDevedorMunicipioFiltro();
    this.exibirGrid = false;
  }

  formSaldoDevedor = new FormGroup({
    DataInicio: new FormControl(undefined, Validators.required),
    DataFim: new FormControl(undefined, Validators.required),
    Municipio: new FormControl()
  });

  ngOnInit() {
    this.dadosOnInitFormulario(this.modalMensagem);
  }

  dadosOnInitFormulario(modal: AslibModalComponent){

    this.observerOnIniftFormulario = this.saldoDevedorMunicipioService.dadosOnInitFormulario().subscribe(
      retornoRequest =>{
        this.listaMunicipio = retornoRequest.ListaMunicipio;
        this.tipoRel  = ExportTypes.PDF;
        this.filtroConsulta();
        this.exibirGrid = false;
        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }
      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }

  public limparConsulta(){
    this.saldoDevedorMunicipioModelView = new SaldoDevedorMunicipioModelView();
  }
  
  public consultarSaldoDevedorMunicipio(modal: AslibModalComponent){

    this.filtroConsulta();
    this.observerOnIniftFormulario = this.saldoDevedorMunicipioService.consultarSaldoDevedorMunicipio(this.filtro).subscribe(
    retornoRequest => {
    this.saldoDevedorMunicipioModelView.ListaSaldoDevedorMunicipio = retornoRequest.ListaSaldoDevedorMunicipio;
   
    let c = this.saldoDevedorMunicipioModelView.ListaSaldoDevedorMunicipio.length
   
    this.exibirGrid = c>0;

    if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
      this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
     }
   },
   () => this.observerOnIniftFormulario.unsubscribe()
 );
}

public filtroConsulta(){
    this.filtro.DataFim = this.DataFim? this.DataFim : null;
    this.filtro.DataInicio= this.DataInicio? this.DataInicio : null;
    this.filtro.IdMunicipio =  this.municipioSelected ? this.municipioSelected.IdMunicipio : null;
    this.filtro.DescricaoMunicipio = this.municipioSelected ? this.municipioSelected.Descricao : null;
  }

  gerarRelatorio(tipoFile: number) {

    let tipoRel: ExportTypes;
    tipoRel = tipoFile==0?ExportTypes.PDF:ExportTypes.Excel_xls;

    this.filtroConsulta();
    this._aslibLoadingService.start();

    this.subscription = this.saldoDevedorMunicipioService
      .gerarRelatorioSaldoDevedorMunicipio(this.filtro,
        tipoRel  )
      .subscribe(
        data => {
          this.showFile.Windows(data,tipoRel);
        },
        (error: any) => {
          this._aslibLoadingService.complete();
          new AslibModalComponent(this._aslibModalService).open({
            title: 'ERRO',
            text: this._messages.MN0011,
            type: 'erro'
          });
        },
        () => {
         this.unSubscribe();
        }
      );
    }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/saldo-devedor-municipio/saldo-devedor-municipio.component.ts